/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AnalyticsModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

import {
    IMsToStringChunk,
    msToStringChunks,
} from 'ng/shared/utils/ms-to-string-chunks.utils';

/**
 * @description Given a milliseconds, converts to appropiate string value.
 * @author Deepak Chaudhary
 */

@Pipe({
    name: 'msToString',
})
export class MsToStringPipe implements PipeTransform {
    public transform(milliseconds: number): string {
        const chunks: IMsToStringChunk[] = msToStringChunks(milliseconds, true);

        return chunks.reduce((acc, { dimension, value }) => {
            acc += `${value + dimension} `;

            return acc;
        }, '');
    }
}
